module.exports = __webpack_public_path__ + "img/placeholder_UF.7d7464c9.jpg";